module.exports = __webpack_public_path__ + "static/media/moon_princess.playngo.abed06b2.jpeg";